import React, { useState } from "react";
import { server } from "../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { NavLink } from "react-router-dom";

const TrackApplication = () => {
  const [dashboard, setDashboard] = useState([]);
  const [applicationNumber, setApplicationNumber] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  // search filter wise
  const FilterData = () => {
    if (!applicationNumber.trim()) {
      toast.warning("Please enter an application number");
      return;
    }

    setHasSearched(true);

    server
      .get(`/user_appl/userapplication/${applicationNumber}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setDashboard([response.data]); // Store the response data in an array
        }
      })
      .catch((error) => {
        setDashboard([]);
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      <div className="container mt-4">
        <div className="card mb-3">
          <h4
            style={{
              backgroundColor: "#81BFDA",
              padding: "10px",
              color: "black",
            }}
          >
            Festival Permission Application Status
          </h4>
          <div className="card-body row">
            <div className="form-group col-md-5">
              <label>अँप्लिकेशन नंबर :</label>
              <input
                type="text"
                className="form-control"
                placeholder="अँप्लिकेशन नंबर:"
                value={applicationNumber}
                onChange={(e) => setApplicationNumber(e.target.value)}
              />
            </div>
            <div className="col-md-2 align-self-center mt-3 ">
              <button
                className="btn btn-info btn-primary "
                onClick={FilterData}
              >
                Submit
              </button>
            </div>
          </div>
        </div>

        {hasSearched && dashboard.length > 0 ? (
          <div className="card mt-4">
            <div className="card-header">Applications List</div>
            <div className="card-body">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Application ID</th>
                    <th>Festival Name</th>
                    <th>Status</th>
                    <th>Applicant Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {dashboard.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.festival_name}</td>
                      <td>{item.permission_status}</td>
                      <td>{item.name}</td>
                      <td>
                        {item.permission_status === "APPROVED" ? (
                          <NavLink
                            className="btn btn-info"
                            to={`/finalpermission/${item.id}`}
                            target="_blank"
                          >
                            Download
                          </NavLink>
                        ) : item.permission_status === "REJECTED" ? (
                          <div>{item.rejection_reason}</div>
                        ) : (
                          "In Process"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : hasSearched ? (
          <div className="alert alert-info mt-4">
            No application found. Please check the application number and try
            again.
          </div>
        ) : null}
      </div>
    </>
  );
};

export default TrackApplication;
